import { HiverAxios, CHANGE_STEP } from 'h-signup'
import { 
    SM_DATA_SUCCESS, 
    SM_DATA_FAILURE,
} 
from './types';

function createSmAndNavigate(params, changeToRoute) {
    return (dispatch) => {
        HiverAxios({
            url: '/gx/api/sm',
            type: 'POST',
            params,
            callback: (response) => {
                dispatch({
                    type: SM_DATA_SUCCESS,
                    payload: { ...params, submitInProgress: false, success: true, sharedmailboxid: response.data.sharedmailboxid }
                });
				dispatch({
                    type: CHANGE_STEP,
                    payload: changeToRoute
                });
            },
            onfail: (e) => {
                console.error(e.response);
                const { response } = e;
				dispatch({
                    type: SM_DATA_FAILURE,
                    payload: { submitError: response.data ? response.data : e, submitInProgress: false }
                });
            }
        })
    }
}
export default createSmAndNavigate;
